import { IAppState } from '../../../AppModulesWrapper';

import { selectIsPromotionPackageSelected } from '../publishTerms';

export function selectCurrentBet(state: IAppState): number {
  const isPromotionPackageSelected = selectIsPromotionPackageSelected(state);

  const { currentOverPackageBet, currentOverServiceBet } = state.servicePickerWidget.auction;

  return isPromotionPackageSelected ? currentOverPackageBet : currentOverServiceBet;
}
